import { useAnalytics, UserProperty } from "@volumental/analytic";
import { Loader } from "@volumental/common";
import type React from "react";
import { useEffect } from "react";
import type { PropsWithChildren } from "react";
import { useInputStore, useSessionStore, useViewStore } from "../store";
import { AppMode, CurrentView } from "../types/types";

export interface InitialViewProviderProps {
  configuration: {
    features: {
      recommendation: {
        enableSurvey: boolean;
      };
    };
  };
}
export function InitialViewProvider({ children }: PropsWithChildren<InitialViewProviderProps>): React.JSX.Element {
  const { setUserProperty } = useAnalytics();
  const { setCurrentView } = useViewStore((store) => store);
  const { mode, isInitialized, token, setInitialized } = useSessionStore((store) => store);

  const { scanID, previousPurchaseID } = useInputStore((store) => store);

  useEffect(() => {
    if (!token) {
      return;
    }
    if (isInitialized) {
      return;
    }
    setUserProperty(UserProperty.TenantToken, token);

    let savedPreScannerView: string | null = null;
    try {
      savedPreScannerView = sessionStorage.getItem("sidebar-pre-scanner-view");
      sessionStorage.removeItem("sidebar-pre-scanner-view");
    } catch {
      // Unavailable in privacy-restricted or sandboxed contexts.
    }
    const hasCallbackState = new URLSearchParams(globalThis.location.search).has("callback_state");

    let initialView = CurrentView.Intro;

    if (
      !hasCallbackState &&
      savedPreScannerView &&
      Object.values(CurrentView).includes(savedPreScannerView as CurrentView)
    ) {
      initialView = savedPreScannerView as CurrentView;
    } else {
      if (mode === AppMode.Measurement && scanID) {
        initialView = CurrentView.Result;
      }
      if (mode === AppMode.Recommendation && (scanID || previousPurchaseID)) {
        initialView = CurrentView.Result;
      }
      if (mode === AppMode.Sizechart) {
        initialView = CurrentView.SizeChart;
      }
    }

    setCurrentView(initialView);
    setInitialized();
  }, [isInitialized, mode, previousPurchaseID, scanID, setCurrentView, setInitialized, setUserProperty, token]);

  if (!isInitialized) {
    return <Loader />;
  }

  return children as React.ReactElement;
}
